import { TEXTOS_UI } from "./textos-ui";
import { UI_ASSETS } from "../../shared/assets";

interface PortadaAventuraProps {
  readonly alEmpezar: () => void;
}

/** Portada #1 aprobada: composición UI por capas sobre el mundo 3D real. */
export function PortadaAventura({ alEmpezar }: PortadaAventuraProps) {
  const titulo = TEXTOS_UI.inicio.tituloAventura;
  const puntoDeCorte = titulo.lastIndexOf(" ");
  const primeraLinea = puntoDeCorte > 0 ? titulo.slice(0, puntoDeCorte) : titulo;
  const segundaLinea = puntoDeCorte > 0 ? titulo.slice(puntoDeCorte + 1) : null;

  return (
    <section className="aventura-portada" aria-labelledby="aventura-portada-titulo">
      <div className="aventura-portada__sol" aria-hidden="true" />
      <header className="aventura-portada__cartel">
        <img className="aventura-portada__madera" src={UI_ASSETS.introTitlePlaque} alt="" aria-hidden="true" />
        <h2 id="aventura-portada-titulo" aria-label={titulo}>
          <span>{primeraLinea}</span>
          {segundaLinea ? <span>{segundaLinea}</span> : null}
        </h2>
        <span className="aventura-portada__estrella" aria-hidden="true">★</span>
        <p className="aventura-portada__subtitulo">{TEXTOS_UI.inicio.subtituloAventura}</p>
      </header>
      <div className="aventura-portada__accion">
        <button
          type="button"
          className="objetivo-tactil boton boton--primario aventura-portada__boton"
          onClick={alEmpezar}
        >
          <span>{TEXTOS_UI.inicio.empezar}</span>
          <span className="aventura-portada__flecha" aria-hidden="true">→</span>
        </button>
        <p>{TEXTOS_UI.inicio.pequenosPasos}</p>
      </div>
    </section>
  );
}

interface HudExploracionProps {
  readonly objetivo: "faro" | "acuerdos" | "punto-encuentro" | "llegada";
  readonly faroVisitado: boolean;
  readonly controlesTactiles: boolean;
}

/** HUD #2 aprobado: objetivo, ruta del capítulo y controles sin cubrir el mundo. */
export function HudExploracion({ objetivo, faroVisitado, controlesTactiles }: HudExploracionProps) {
  const etapaActiva = objetivo === "faro" ? "faro" : "acuerdos";
  const objetivoTexto = {
    faro: TEXTOS_UI.inicio.objetivoFaro,
    acuerdos: TEXTOS_UI.inicio.objetivoAcuerdos,
    "punto-encuentro": TEXTOS_UI.inicio.objetivoPuntoEncuentro,
    llegada: TEXTOS_UI.inicio.objetivoLlegada,
  }[objetivo];

  return (
    <aside className={`exploracion-hud${controlesTactiles ? " exploracion-hud--tactil" : ""}`} aria-label={TEXTOS_UI.mundo.region}>
      <section className="exploracion-hud__objetivo" aria-live="polite">
        <span>{TEXTOS_UI.inicio.objetivoLabel}</span>
        <strong>{objetivoTexto}</strong>
      </section>

      <nav
        className={`exploracion-hud__ruta${faroVisitado ? " exploracion-hud__ruta--faro-visitado" : ""}`}
        aria-label={TEXTOS_UI.inicio.rutaCapituloLabel}
      >
        <ol>
          {TEXTOS_UI.inicio.rutaCapitulo.map((etapa) => {
            const id = etapa.toLocaleLowerCase("es");
            const completada = id === "partida" ||
              (id === "faro" && faroVisitado) ||
              (id === "acuerdos" && (objetivo === "punto-encuentro" || objetivo === "llegada"));
            return (
              <li
                key={etapa}
                aria-current={id === etapaActiva ? "step" : undefined}
                data-completada={completada || undefined}
              >
                <span className="exploracion-hud__punto" aria-hidden="true" />
                <span>{etapa}</span>
              </li>
            );
          })}
        </ol>
      </nav>

      {controlesTactiles ? null : (
        <p className="exploracion-hud__controles">{TEXTOS_UI.inicio.controlesTeclado}</p>
      )}
    </aside>
  );
}
